export const fieldEditButtonSelectorName = 'jira-issue-field-edit-field-edit-button';
export const FIELD_EDIT_BUTTON_COMPONENT_SELECTOR = `[data-component-selector="${fieldEditButtonSelectorName}"]`;
